export default {
  system: {
    user: 'ผู้ใช้',
    level: 'ระดับ',
    earnPerTap: 'รายได้ต่อการแตะ',
    coinsToLevelUp: 'เหรียญที่ต้องการเพื่อเลเวลอัพ',
    profitPerHour: 'กำไรต่อชั่วโมง',
    coming1: 'บางสิ่งที่น่าสนใจ',
    coming2: 'กำลังจะมาในเร็วๆ นี้....',
    close: 'ปิด',
    friends: 'เพื่อน',
    continue: 'ดำเนินการต่อ',
  },
  settings: {
    chooseNetwork: 'เลือกเครือข่าย',
    chooseLanguage: 'เลือกภาษา',
  },
  popup_CheckTask: {
    join: 'เข้าร่วม',
    check: 'ตรวจสอบ',
    taskIsNotCompleted: 'งานยังไม่เสร็จ',
  },
  popup_levelUp: {
    levelUp: 'เลเวลอัพ!',
    multiTap: 'การแตะหลายครั้ง',
    energyLimit: 'ขีดจำกัดพลังงาน',
  },
  popup_BalanceUp: {
    balanceUp: 'อัพเดทยอดเงิน!',
    balanceDiffSinceLast: 'รางวัลของคุณ',
  },
  popup_BalanceTip: {
    tip: 'เพิ่มกำไรของคุณ',
    message: 'แตะที่เมนูขุดเหมืองเพื่อซื้อการอัพเกรดสำหรับเครือข่ายของคุณ',
    description: 'รับรายได้แม้ในขณะออฟไลน์สูงสุด 3 ชั่วโมง',
  },
  popup_Bored: {
    header: 'กบกำลังเบื่อ!',
    message: 'เล่นกับกบ',
    description: 'หากไม่มีการเล่นกับกบเป็นเวลา 3 ชั่วโมง กำไรจะหยุดลง',
  },
  popup_Hungry: {
    header: 'กบกำลังหิว!',
    message: 'ให้อาหารกบ',
    description: 'ยิ่งคุณมีเพื่อนมาก ยิ่งได้เหรียญมากขึ้นในแต่ละครั้งที่ให้อาหาร',
  },
  menu: {
    network: 'เครือข่าย',
    mine: 'ขุดเหมือง',
    earn: 'รายได้',
    food: 'อาหาร',
  },
  tap: {
    bored: 'เบื่อ',
    fun: 'สนุก',
  },
  mineMenu: {
    activities: 'กิจกรรม',
    investments: 'การลงทุน',
    web3: 'WEB3',
    achievements: 'ความสำเร็จ',
  },
  leaderboard: {
    from: 'จาก',
    beTheFirst: 'เป็นคนแรก!',
  },
  mine: {
    joinOurTG1: 'เข้าร่วมช่อง Telegram ของเรา',
    joinOurTG2: 'เพื่อปลดล็อค!',
    unlock: 'ปลดล็อค',
  },
  friends: {
    inviteFriends: 'เชิญเพื่อน!',
    receiveBonuses: 'คุณและเพื่อนของคุณจะได้รับโบนัส',
    inviteFriend: 'เชิญเพื่อน',
    withTelegramPremium: 'ด้วย Telegram Premium',
    forYouAndYourFriend: 'สำหรับคุณและเพื่อนของคุณ',
    moreBonuses: 'โบนัสเพิ่มเติม',
    listOfYourFriends: 'รายชื่อเพื่อนของคุณ',
    linkCopied: 'ลิงก์เชิญได้ถูกคัดลอกไปยังคลิปบอร์ดของคุณแล้ว!',
    playWithMe:
      'มาร่วมเล่นกับฉันและรับโทเคนผ่าน airdrop!\n' +
      '💰 รับของขวัญ! +3000 เหรียญสำหรับผู้เล่นใหม่\n' +
      '🚀 มี Telegram Premium? รับ +5000 เหรียญ!\n',
  },
  earn: {
    moreCoins: 'รับเหรียญเพิ่ม!',
    dailyTasks: 'ภารกิจประจำวัน',
    dailyReward: 'รางวัลประจำวัน',
    tasksList: 'รายการภารกิจ',
    joinOurTG: 'เข้าร่วมช่อง Telegram ของเรา',
    followOurX: 'ติดตามบัญชี X ของเรา',
    yourAd: 'โฆษณาของคุณอาจอยู่ที่นี่',
    connect: 'ติดต่อผู้ดูแลช่อง Telegram ของเรา',
  },
  food: {
    hungry: 'หิว',
    full: 'อิ่ม',
    frogIsFull: 'กบอิ่มแล้ว',
    feed: 'ให้อาหาร',
    bonus: 'โบนัส',
    satiety: 'ความอิ่ม',
    hours: 'ชั่วโมง',
  },
  toast: {
    buyCard: {
      title: 'ปลดล็อกความสำเร็จ!',
      subtitle: 'ถึงเวลานำจักรวรรดิกบของคุณไปสู่ความยิ่งใหญ่ 👑',
    },
    feedFrog: {
      title: 'กบมีความสุข!',
      subtitle: 'ทำได้ดีมาก! ให้อาหารสัตว์เลี้ยงของคุณเพื่อรักษารอยยิ้ม 🍽️',
    },
  },
};
